import "./App.css";
import FlavorForm from "./FlavorForm";

function App() {
  return (
    <div className="overflow-y-auto h-[100vh] pb-3">
      <FlavorForm />
    </div>
  );
}

export default App;
